var map = {
	"./quiz-pic-0.jpeg": 1102,
	"./quiz-pic-1.jpeg": 1103,
	"./quiz-pic-2.jpeg": 1104,
	"./quiz-pic-3.jpeg": 1105,
	"./quiz-pic-4.jpeg": 1106,
	"./quiz-pic-5.jpeg": 1107,
	"./quiz-pic-6.jpeg": 1108,
	"./quiz-pic-7.jpeg": 1109,
	"./quiz-pic-8.jpeg": 1110,
	"./quiz-pic-9.jpeg": 1111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1101;